'use client';
import React from 'react';

interface ExpertiseCard {
  title: string;
  href: string;
  bgPattern: string;
}

const expertiseCards: ExpertiseCard[] = [
{
  title: 'Development',
  href: '#expertise',
  bgPattern: 'https://tmo.com/wp-content/uploads/2024/07/pattern-bg-01.png'
},
{
  title: 'Management',
  href: '#expertise',
  bgPattern: 'https://tmo.com/wp-content/uploads/2024/07/pattern-bg-02.png'
},
{
  title: 'Construction',
  href: '#expertise',
  bgPattern: 'https://tmo.com/wp-content/uploads/2024/07/pattern-bg-03.png'
},
{
  title: 'Investment',
  href: '#expertise',
  bgPattern: 'https://tmo.com/wp-content/uploads/2024/07/pattern-bg-04.png'
}];


export default function TeaserSection() {
  return (
    <section
      id="expertise"
      className="py-12 md:py-16 lg:py-20"
      style={{ backgroundColor: 'rgba(109, 207, 246, 0.1)' }}>

      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* Showcase Image */}
        <div className="mb-8 md:mb-10 overflow-hidden">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_1b5804cd4-1767581332149.png"
            alt="Brickwell Housing community development team working on a residential project site"
            className="w-full object-cover block"
            style={{ height: 'clamp(200px, 30vw, 400px)' }} />

        </div>

        {/* Section Header */}
        <div className="mb-8">
          <h2
            style={{
              fontSize: 'clamp(22px, 3vw, 36px)',
              fontWeight: 400,
              color: '#003c82',
              margin: 0,
              fontFamily: 'Montserrat, sans-serif'
            }}>

            Commitment &amp; Passion Every Step of The Way
          </h2>
        </div>

        {/* Expertise Cards Grid — 1 col mobile, 2 col sm, 4 col lg */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {expertiseCards.map((card) =>
          <a
            key={card.title}
            href={card.href}
            className="block"
            style={{
              backgroundColor: '#003c82',
              padding: 'clamp(24px, 3vw, 40px) clamp(20px, 2.5vw, 30px)',
              position: 'relative',
              overflow: 'hidden',
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minHeight: '140px',
              transition: 'background-color 0.3s ease'
            }}
            onMouseEnter={(e) => {(e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#002a5c';}}
            onMouseLeave={(e) => {(e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#003c82';}}>

              {/* Background Pattern */}
              <div
              style={{
                position: 'absolute',
                inset: 0,
                backgroundImage: `url('${card.bgPattern}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.15
              }} />


              {/* Title */}
              <h3
              style={{
                color: '#ffffff',
                fontSize: 'clamp(18px, 2vw, 22px)',
                fontWeight: 500,
                margin: 0,
                position: 'relative',
                zIndex: 1,
                fontFamily: 'Montserrat, sans-serif'
              }}>

                {card.title}
              </h3>

              {/* Arrow */}
              <div
              style={{
                color: '#ffffff',
                position: 'relative',
                zIndex: 1,
                alignSelf: 'flex-end'
              }}>

                <svg width="32" height="16" viewBox="0 0 39 32" fill="none">
                  <path d="M22.721 1.228l15.015 15.015-15.015 15.015" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M37.791 16.242h-37.606" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

}